module.exports = __webpack_public_path__ + "img/slogan@2x.eeb7c829.png";